import { Box, Typography } from "@mui/material";

import Logo from './../../assets/images/logo.svg';

const PageLoader = () => {
    return (
        <Box className="page-loader" sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#fff",
            height: "100vh"
        }}>
            <img src={Logo} alt="NINC LOGO" />
            <Typography fontWeight={400} color="#000" marginTop={"2rem"} sx={{fontSize: {xs: "0.75em", md: "1em"}}}>Loading...</Typography>

        </Box>
    )
};

export default PageLoader;